import { logEvent } from 'utils/eventTracking';
import { NavigationLink, SideBar } from './styles';

interface INavigationProps {
  selected: string;
  setSelectedNavigation: (selected: string) => void;
  navigationLinks: { label: string; id: string; trackingEvent: string }[];
}

const Navigation = (props: INavigationProps) => {
  const { selected, setSelectedNavigation, navigationLinks } = props;

  const onLinkClick = (id: string, event: string) => () => {
    logEvent(event);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top });
      setSelectedNavigation(id);
    }
  };
  return (
    <div>
      <SideBar flexDirection="column">
        {navigationLinks.map(({ id, label, trackingEvent }) => (
          <NavigationLink
            isSelected={selected === id}
            onClick={onLinkClick(id, trackingEvent)}
          >
            {label}
          </NavigationLink>
        ))}
      </SideBar>
    </div>
  );
};

export default Navigation;
